import request from "@/utils/request";

let warnList = [];
let warnCommentList = [];

const initWarnList = function(params) {
    const count = parseInt(params.limit);
    for (const index in [...Array(count)]) {
        const seq = parseInt(index) + 1;
        const warnItem = {warnSeq:seq, typeCd:'105002', topicCd:'364003', title:`컨텐츠${seq}`, 
            writerId:`regId_${seq}`, report:`신고합니다_${seq}`, reporterId:`warnId_${seq}`, regDt:'2022-03-10',
            statusCd:'368001', statusComment:'',
            writerName:`regId_${seq}이름`, writerEmail:`regId_${seq}@test.com`,
            reporterName:`warnId_${seq}이름`, reporterEmail:`warnId_${seq}@test.com`,};
        warnList.push(warnItem);
    }
}

const initWarnCommentList = function(params) {

}

const getTestWarnList = async function(params) {
    console.log('getTestWarnList:', params.limit);

    if (warnList.length == 0) {
        initWarnList(params);
    }
    const result = {
        data: warnList
    }
    result.count = warnList.length;
    return result;
}

const getTestWarnCommentList = async function(params) {
    console.log('getTestWarnCommentList:', params.limit);

    if (warnCommentList.length == 0) {
        initWarnCommentList(params);
    }
    const result = {
        data: warnCommentList
    }
    result.count = warnCommentList.length;
    return result;
}

const updateWarnItemTest = async function(params) {
    const warnSeq = params.warnSeq;
    const statusCd = params.statusCd;
    const statusComment = params.statusComment;
    const findItem = warnList.find((item) => item.warnSeq == warnSeq);
    if (findItem) {
        if (statusCd) {
            findItem.statusCd = statusCd;
        }
        if (statusComment) {
            findItem.statusComment = statusComment;
        }
        return findItem;
    } else {
        throw new Error('해당 항목이 없습니다.');
    }
}

const updateCommentStatusTest = async function(params) {
    
}

const deleteCommentTest = async function(params) {
    
}

const registerCommentTest = async function(params) {
    
}

const sendEmailTest = async function(params) {
    //throw new Error('발송 실패되었습니다. 죄송합니다.');
}

const getTestWarnUserList = async function(params) {

}

// Test List
const getTestList = async function(params, testList, initFunc) {
    if (testList.length == 0) {
        initFunc(params);
    }
    if (params.limit == 0) {
        return {
            data: testList,
            count: testList.length
        }
    }
    const offset = (params.page - 1) * params.limit;
    const result = {
        data: testList.slice(offset, offset + params.limit),
        count: testList.length
    }
    return result;
}

// 금칙어 Test
let badWordList = [];
let defaultBadWordCount = 52;
let badWordInsSeq = 0;
const initBadWordList = function(params) {
    const count = parseInt(defaultBadWordCount);
    for (const index in [...Array(count)]) {
        const seq = parseInt(index) + 1;
        const badWordItem = {wordSeq:seq, word:`이런_${seq}`,
            regId:`regId_${seq}`, status:'Y', regDt:'2022-03-10'};
        badWordList.push(badWordItem);
    }
    badWordInsSeq = count + 1;
}

const getTestBadWordList = async function(params) {
    return await getTestList(params, badWordList, initBadWordList);
}

const registerBadWordTest = async function(paramList) {
    const addItemList = [];
    paramList.forEach((paramItem) => {
        const word = paramItem.word;
        const status = paramItem.status;
        const addItem = {wordSeq:badWordInsSeq, word:word,
            regId:`regId_100`, status:status, regDt:'2022-03-10'};
        addItemList.push(addItem);
        badWordInsSeq = badWordInsSeq + 1;
    });
    badWordList.splice(0, 0, ...addItemList);
}

const updateBadWordTest = async function(params) {
    const wordSeq = params.wordSeq;
    const word = params.word;

    badWordList.forEach((item) => {
        if (item.wordSeq == wordSeq) {
            item.word = word;
        }
    });
}

const applyBadWordTest = async function(params, isApply) {
    const selectedList = params;
    const selectedSeqs = selectedList.map((item) => item.wordSeq);
    badWordList.forEach((item) => {
        if (selectedSeqs.includes(item.wordSeq)) {
            item.status = isApply ? 'Y' : 'N';
        }
    });

    return {data:true};
}

const deleteBadWordTest = async function(params) {
    const selectedList = params;
    const selectedSeqs = selectedList.map((item) => item.wordSeq);
    _.remove(badWordList, (item) => {
        return selectedSeqs.includes(item.wordSeq);
    })

    return {data:true};
}

// 프리톡 테스트
let freeTalkList = [];
let defaultFreeTalkCount = 52;
const initFreeTalkList = function(params) {
    const count = parseInt(defaultFreeTalkCount);
    for (const index in [...Array(count)]) {
        const seq = parseInt(index) + 1;
        const cmmtCount = Math.floor(Math.random() * 10);
        const likeCount = Math.floor(Math.random() * 10);
        const warnCount = Math.floor(Math.random() * 10);
        const freeTalkItem = {freeSeq:seq, subject:`프리톡_${seq}`,
            content:seq==2 ? '도형의 원리 아이들이 쉽게 이해할 수 있는 방법 알려주세요. 교과서로는 한계가 있습니다.\
             학생들 간의 격차도 많고요. 정말 이해를 하는 건지 못하는 건지 알 수가 없어서 가르치기 너무나 힘.. 전체 내용 보여주세요.\
            ' : (seq==1 ? '이것은 또다른 예제입니다. 또 다른 게시글입니다. 긴 게시글 테스트입니다. 잘 되야 할텐데. 걱정하지 마세요.\
            잘되겠죠. 아하하하하하. 후후후후후.' : `프리톡 내용_${seq}`),
            authorId:`regId_${seq}`, regDt:'2022-03-10',
            cmmtCount:cmmtCount, likeCount:likeCount, warnCount:warnCount};
        freeTalkList.push(freeTalkItem);
    }
}

const getTestFreeTalkList = async function(params) {
    return await getTestList(params, freeTalkList, initFreeTalkList);
}

// 댓글 테스트
let commentList = [];
let defaultCommentCount = 52;
const initCommentList = function(params) {
    const count = parseInt(defaultCommentCount);
    for (const index in [...Array(count)]) {
        const seq = parseInt(index) + 1;
        const commentItem = {cmmtSeq:seq, title:`게시글_${seq}`,
            contents:`댓글 내용_${seq}`,
            userId:`regId_${seq}`, regDt:'2022-03-10',
            typeCd:'105002', topicCd:'361005', cmmtStatusCd:'374001'};
        commentList.push(commentItem);
    }
}

const getTestCommentList = async function(params) {
    return await getTestList(params, commentList, initCommentList);
}


// 신고 게시글 : 목록
export async function getWarnList(params, isTest) {
    console.log("@@ get list : getWarnList");
    return isTest ? getTestWarnList(params) : request.get("/api/community/warn/", {params});
}

// 신고 댓글 : 목록
export async function getWarnCommentList(params, isTest) {
    console.log("@@ get list : getWarnCommentList");
    return isTest ? getTestWarnCommentList(params) : request.get("/api/community/warn/comment", {params});
}

// 신고 게시글/댓글 : 처리상태 변경 또는 메모 추가
export async function updateWarnItem(params, isTest) {
    console.log("@@ updateWarnItem");
    return isTest ? updateWarnItemTest(params) : request.post("/api/community/warn/", params);
}

// 신고 댓글 : 댓글 노출/비노출 상태 변경
export async function updateCommentStatus(params, isTest) {
    console.log("@@ updateCommentStatus");
    return isTest ? updateCommentStatusTest(params) : request.post("/api/community/comment/", params);
}

// 신고 댓글 : 댓글 삭제
export async function deleteComment(params, isTest) {
    console.log("@@ deleteComment");
    const config = {params:params};
    return isTest ? deleteCommentTest(params) : request.delete("/api/community/comment/", config);
}

// 신고 댓글 : 답글달기
export async function registerComment(params, isTest) {
    console.log("@@ registerComment");
    return isTest ? registerCommentTest(params) : request.post("/api/community/comment/recomment", params);
}

// 이메일 보내기
export async function sendWarnEmail(params, isTest) {
    console.log("@@ sendEmail");
    return isTest ? sendEmailTest(params) : request.post("/api/community/warn/sendEmail", params);
}

// 신고자/피신고자 목록
export async function getWarnUserList(params, isTest) {
    console.log("@@ get list : getWarnUserList");
    return isTest ? getTestWarnUserList(params) : request.get("/api/community/warn/warnUser", {params});
}

// 금칙어 목록
export async function getBadWordList(params, isTest) {
    console.log("@@ get list : getBadWordList");
    const config = {params:params};
    return isTest ? getTestBadWordList(params) : request.get("/api/community/badWord/", config);
}

// 금칙어 등록/일괄 등록
export async function registerBadWord(params, isTest) {
    console.log("@@ get list : registerBadWord");
    return isTest ? registerBadWordTest(params) : request.post("/api/community/badWord/", params);
}

// 금칙어 수정
export async function updateBadWord(params, isTest) {
    console.log("@@ get list : updateBadWord");
    return isTest ? updateBadWordTest(params) : request.post("/api/community/badWord/update", params);
}

// 금칙어 상태변경 (적용/보류)
export async function updateStatus(params, isTest) {
    console.log("@@ get list : applyBadWord");
    return isTest ? applyBadWordTest(params, isApply) : request.post("/api/community/badWord/updateStatus", params);
}

// 금칙어 삭제
export async function deleteBadWord(params, isTest) {
    console.log("@@ get list : deleteBadWord");
    return isTest ? deleteBadWordTest(params) : request.post("/api/community/badWord/delete", params);
}

// 나눔자료 목록
export async function getSharingContentsList(params, isTest) {
    console.log("@@ get list : getSharingContentsList");
    const config = {params:params};
    return isTest ? getTestSharingContentsList(params) : request.get("/api/community/sharingContents/", config);
}

// 나눔자료 게시판 글의 댓글 목록
export async function getSharingContentsCommentList(params, isTest) {
    console.log("@@ get list : getSharingContentsCommentList");
    const config = {params:params};
    return isTest ? getTestCommentList(params) : request.get("/api/community/comment/sharingContents/", config);
}

// 온라인콘텐츠 목록 : OnlineContentsApi.js 의 getOnlineContentsList 와 동일
export async function getOnlineContentsList(params, isTest) {
    console.log("@@ get list : getOnlineContentsList");
    const config = {params:params};
    return isTest ? getTestOnlineContentsList(params) : request.get("/api/online/onlineContents/", config);
}

// 이슈톡 목록
export async function getIssueTalkList(params, isTest) {
    console.log("@@ get list : getIssueTalkList");
    const config = {params:params};
    return isTest ? getTestIssueTalkList(params) : request.get("/api/community/issueTalk/", config);
}

// 프리톡 목록
export async function getFreeTalkList(params, isTest) {
    console.log("@@ get list : getFreeTalkList");
    const config = {params:params};
    return isTest ? getTestFreeTalkList(params) : request.get("/api/community/freeTalk/", config);
}

// 프리톡 게시판 글의 댓글 목록
export async function getFreeTalkCommentList(params, isTest) {
    console.log("@@ get list : getFreeTalkCommentList");
    const config = {params:params};
    return isTest ? getTestCommentList(params) : request.get("/api/community/comment/freeTalk/", config);
}

// 전체 댓글 목록
export async function getAllCommentList(params, isTest) {
    console.log("@@ get list : getAllCommentList");
    const config = {params:params};
    return isTest ? getTestCommentList(params) : request.get("/api/community/comment/", config);
}




